import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeaders } from "../user/user.api";
import { PaginationResults, TypeQuery } from "../user/user.type";
import { ApiBaseUrl } from "../../http";
import { INotification } from '../dashboard/dashboard.type';
import { QueryUrl } from '../../Utils';
import { NotificationFormData } from './notification.type';

const NotificationApi = createApi({
    reducerPath: "notificationApi",
    tagTypes: ["notification"],
    baseQuery: fetchBaseQuery({
        baseUrl: `${ApiBaseUrl}/api/`,
        prepareHeaders,
    }),
    endpoints: (build) => ({
        addOrUpdateNotification: build.mutation<
            INotification,
            { slug?: string; data: INotification }
        >({
            query: ({ slug, data }) => ({
                url: slug ? `notifications/${slug}/` : `notifications/`,
                method: slug ? "PUT" : "POST",
                body: data,
            }),
            invalidatesTags: ["notification"],
        }),
        updateReadNotification: build.mutation<
            INotification,
            NotificationFormData
        >({
            query: ({ slug, ...data }) => ({
            url: `notifications/${slug}/`,
            method: "PUT",
            body: data,
            }),
            invalidatesTags: ["notification"],
        }),
        getNotifications: build.query<PaginationResults<INotification>, TypeQuery>({
            query: (query) => QueryUrl("notifications", query),
            providesTags: ["notification"],
        }),
        getNotificationByUser: build.query<PaginationResults<INotification>, TypeQuery>({
            query: ({ slug, ...query }) => QueryUrl(`user/${slug}/notifications/`, query),
            providesTags: ["notification"],
        }),
        getNotificationByAdmin: build.query<PaginationResults<INotification>, TypeQuery>({
            query: ({ slug, ...query }) => QueryUrl(`admin/${slug}/notifications/`, query),
            providesTags: ["notification"],
        }),
    }),
});

export default NotificationApi

export const {
    useUpdateReadNotificationMutation,
    useAddOrUpdateNotificationMutation,
    useGetNotificationByUserQuery,
    useGetNotificationByAdminQuery,
    useGetNotificationsQuery
} = NotificationApi;